import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { AgendaService } from 'src/app/global/services/agenda.service';
import { AnexoContratoService } from 'src/app/global/services/anexo-contrato.service';
import { BancoService } from 'src/app/global/services/banco.service';
import { CuentaAbonoService } from 'src/app/global/services/cuenta-abono.service';
import { CuotasService } from 'src/app/global/services/cuotas.service';
import { DatosComercioService } from 'src/app/global/services/datos-comercio.service';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { ValidacionEdicionService } from 'src/app/global/services/validacion-edicion.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { GoToPaso3ServiceVM } from 'src/app/view-model/services/go-to-paso3.service';
import { environment } from 'src/environments/environment';



@Injectable()
export class GoToPaso3ProviderVM extends GoToPaso3ServiceVM {

    private dataPaso3: Paso3 = {
        datosAgenda: undefined,
        datoCuota: undefined,
        dataCuentaAbono: undefined,
        datosComercio: undefined,
        tipoAprobacion: undefined,
        validaPaso3: undefined,
        persona: undefined,
        nacionalidades: undefined
    };

    constructor(
        private abonoService: CuentaAbonoService,
        private agendaService: AgendaService,
        private bancoService: BancoService,
        private carroComprasService: CarroComprasService,
        private cuotasService: CuotasService,
        private datosComercio: DatosComercioService,
        private datosPersona: DatosPersonalesService,
        private localStorageService: LocalStorageService,
        private terminosService: AnexoContratoService,
        private validaPaso3: ValidacionEdicionService,
        private route: ActivatedRoute
    ) {
        super();
    }


    private getAgenda(): Observable<any> {

        const cbOK = response => {

            if (response.indicador) {
                if (response.indicador === 'COMERCIO_NO_AGENDABLE') {
                    return undefined;
                }
            }

            return response;
        };

        const cbError = error => {
            return of(undefined);
        };

        return this.agendaService.getAgenda()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private getCuotas(): Observable<any> {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.cuotasService.getCuotas()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private getDatosComercio(): Observable<any> {
        const cbOK = response => {
            if (response.indicador) {
                if (response.indicador === 'COMERCIO_FORMAL_NO_SOPORTADO') {
                    return response;
                }
            }
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        const correo: string = this.localStorageService.getPaso1Login() != null ? this.localStorageService.getPaso1Login().correo : 'correo@correo.cl';

        return this.datosComercio.obtieneIdentificacionComercio(correo)
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private getCuentaAbono(): Observable<any> {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.abonoService.getCuentaAbono()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private getValidaPaso3(): Observable<any> {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.validaPaso3.getValidacionEdicion()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private tipoAprobacion() {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.terminosService.getTipoAprobacion()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private obtenerBancos() {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.bancoService.getBancos()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private obtenerNacionalidades() {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.datosPersona.getNacionalidades()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    private datosPersonales() {
        const cbOK = response => {
            return response;
        };

        const cbError = error => {
            return throwError(error);
        };

        return this.datosPersona.getDatosPersonales()
            .pipe(map(cbOK))
            .pipe(catchError(cbError));
    }

    async goToPaso3(): Promise<any> {
        const paso1 = this.localStorageService.getPaso1Login();

        try {
            const responseAgenda = await this.getAgenda().toPromise();
            this.dataPaso3.datosAgenda = responseAgenda;
            const responseCuotas = await this.getCuotas().toPromise();
            this.dataPaso3.datoCuota = responseCuotas;
            const responseDatosComercio = await this.getDatosComercio().toPromise();
            this.dataPaso3.datosComercio = responseDatosComercio;
            const responseCuentaAbono = await this.getCuentaAbono().toPromise();
            this.dataPaso3.dataCuentaAbono = responseCuentaAbono;
            const responseTipoAprobacion = await this.tipoAprobacion().toPromise();
            this.dataPaso3.tipoAprobacion = responseTipoAprobacion;
            const responseBancos = await this.obtenerBancos().toPromise();
            this.dataPaso3.bancos = responseBancos;
            if (paso1 == null || paso1.currentIsPersonaNatural) {
                const responseDatosPersonales = await this.datosPersonales().toPromise();
                this.dataPaso3.persona = responseDatosPersonales;
            }
            const responseNacionalidades = await this.obtenerNacionalidades().toPromise();
            this.dataPaso3.nacionalidades = responseNacionalidades;
            const responseValidaEdicion = await this.getValidaPaso3().toPromise();
            this.dataPaso3.validaPaso3 = responseValidaEdicion;

            //Check Query param Looking for Soicos mark
            let param = this.route.snapshot.queryParamMap.get('utm_source'); 
            if( param != undefined){
                this.dataPaso3.soicos = {
                    isSoicos: true,
                    total: null,
                    isVenta: null
                }
            }

            this.dataPaso3.validaPaso3 = responseValidaEdicion;
            this.localStorageService.setPaso3(this.dataPaso3);
            this.localStorageService.setCurrentPage(_.get(environment, 'localStorage.PASO_3', ''));
            this.carroComprasService.changePaso('P_3');
            return 'GOTO_PASO_3';
        } catch (e) {
            console.error('No fue posible obtener información de Paso3', e);
            return throwError(e);
        }
    }
}
